module.exports = __webpack_public_path__ + "static/media/Sportforia_News_Picture.33e7af07.png";